/* Import
--------------------------------------------------------------------------------------- */
import Splide from '@splidejs/splide'

/* kbb-images-slider
--------------------------------------------------------------------------------------- */
var kbbSliders = document.getElementsByClassName('kbb-splide')
for (var i = 0, len = kbbSliders.length; i < len; i++) {
    new Splide(kbbSliders[i]).mount()
}

/* block: tabs
--------------------------------------------------------------------------------------- */
let tabsBlockEl = document.querySelectorAll('.bblocks-tabs')

if (tabsBlockEl.length > 0) {
    for (let tabsEl of tabsBlockEl) {
        let listItemsEl = tabsEl.querySelectorAll('.bblocks-tab-list-item')
        let contentsEl = tabsEl.querySelectorAll('.bblocks-tab')

        if (listItemsEl.length > 0) {
            for (let itemEl of listItemsEl) {
                if (itemEl.classList.contains('bblocks-tab-list-active')) {
                    let currTabName = itemEl.dataset.bblocksTabName
                    let tabCtntEl = tabsEl.querySelector(
                        '.bblocks-tab[data-bblocks-tab-name="' + currTabName + '"]'
                    )

                    contentsEl.forEach((el) => el.classList.remove('bblocks-active-tab'))
                    tabCtntEl.classList.add('bblocks-active-tab')
                }

                itemEl.addEventListener('click', () => {
                    listItemsEl.forEach((el) => el.classList.remove('bblocks-tab-list-active'))
                    itemEl.classList.add('bblocks-tab-list-active')

                    // Display tab content
                    let currTabName = itemEl.dataset.bblocksTabName
                    let tabCtntEl = tabsEl.querySelector(
                        '.bblocks-tab[data-bblocks-tab-name="' + currTabName + '"]'
                    )

                    contentsEl.forEach((el) => el.classList.remove('bblocks-active-tab'))
                    tabCtntEl.classList.add('bblocks-active-tab')
                })
            }
        }
    }
}
